export function rnds() {
	return ["1", "2", "3"];
}

export function tees() {
	return ["0", "1", "10"];
}



// WEBPACK FOOTER //
// ./src/helpers.js